export default __webpack_public_path__ + "static/media/apple-omega-bangles-icon.21959926.png";